/**
 * Redux reducer for axis orders.
 * @module redux/reducers/axisOrders
 */

import update from 'immutability-helper';
import {
  REQUEST_DELIVERY_FEED,
  DELIVERY_FEED_RECEIVED,
  REQUEST_DELIVERY_FEED_FAILED,
  REQUEST_ORDER_STATUS,
  ORDER_STATUS_RECEIVED,
  REQUEST_ORDER_STATUS_FAILED,
  ORDER_ITEMS_TOGGLED,
  REQUEST_MAP_STATUS,
  MAP_STATUS_RECEIVED,
  REQUEST_MAP_STATUS_FAILED
} from './../actions/axisOrders';

const initialState = {
  deliveryFeed: [],
  deliveryFeedLoading: false,
  orders: [],
  orderStatusLoading: false,
  maps: [],
  mapStatusLoading: false
};

const ACTION_HANDLERS = {
  [REQUEST_DELIVERY_FEED]: (state) => ({
    ...state,
    deliveryFeedLoading: true
  }),
  [DELIVERY_FEED_RECEIVED]: (state, action) => ({
    ...state,
    deliveryFeed: action.payload.feed || [],
    deliveryFeedLoading: false
  }),
  [REQUEST_DELIVERY_FEED_FAILED]: (state) => ({
    ...state,
    deliveryFeedLoading: false
  }),
  [REQUEST_ORDER_STATUS]: (state) => ({
    ...state,
    orderStatusLoading: true
  }),
  [ORDER_STATUS_RECEIVED]: (state, action) => ({
    ...state,
    orders: action.payload.orderStatus || [],
    orderStatusLoading: false
  }),
  [REQUEST_ORDER_STATUS_FAILED]: (state) => ({
    ...state,
    orderStatusLoading: false
  }),
  [ORDER_ITEMS_TOGGLED]: (state, action) => {
    const index = state.orders.findIndex(o => o.id === action.payload.id);
    return update(state, {
      orders: {
        [index]: {
          expanded: { $set: action.payload.expanded }
        }
      }
    });
  },
  [REQUEST_MAP_STATUS]: (state) => ({
    ...state,
    mapStatusLoading: true
  }),
  [MAP_STATUS_RECEIVED]: (state, action) => ({
    ...state,
    maps: action.payload.maps || [],
    mapStatusLoading: false
  }),
  [REQUEST_MAP_STATUS_FAILED]: (state) => ({
    ...state,
    mapStatusLoading: false
  })
};

export default function axisOrders(state = initialState, action) {
  const handler = ACTION_HANDLERS[action.type];

  return handler ? handler(state, action) : state;
}



// WEBPACK FOOTER //
// ./app/reducers/axisOrders.js